module.exports = __webpack_public_path__ + "media/images/gallery/constellations/capricornus/cap_border-d5e7136b17f3a08874eb985425543251.gif";